import React, {
  PropTypes as T,
} from 'react';
import radium from 'radium';
import _ from 'lodash';

const style = {
  wrap: {
    display: 'inline-flex',
    margin: '0 6px',
    alignItems: 'center',
    cursor: 'pointer',
    position: 'relative',
  },
  label: {
    fontSize: 24,
    color: '#aaa',
    fontWeight: 200,
    letterSpacing: 1,
    cursor: 'pointer',
    transition: 'color .24s ease-out',
  },
  labelActived: {
    color: '#9B9B9B',
  },
  container: {
    backgroundColor: 'white',
    margin: '0 20px 0 0',
    borderRadius: 15,
    width: 60,
    height: 30,
    display: 'block',
    border: '3px solid #aaa',
  },
  ball: {
    position: 'absolute',
    backgroundColor: '#aaa',
    width: 35,
    height: 35,
    display: 'block',
    borderRadius: '50%',
    top: -3,
    left: 0,
    transition: 'color .24s ease-out, left .3s ease-out',
  },
  containerActived: {

  },
  ballActived: {
    left: 30,
  },
};

function Switch(props) {
  const isActived = props.isActived;
  const styles = _.cloneDeep(style);
  styles.ball.backgroundColor = props.color;
  if (isActived) {
    styles.containerActived.backgroundColor = `${props.bgColor}`;
    styles.container.border = `3px solid ${props.bgColor}`;
  } else {
    styles.container.border = `3px solid ${props.color}`;
  }


  return (
    <div style={styles.wrap} onClick={() => props.switch(props.field, !isActived)}>
      <div style={[styles.container, isActived && styles.containerActived]}>

      </div>
      <span style={[styles.ball, isActived && styles.ballActived]}></span>
      <label style={[styles.label, isActived && styles.labelActived]}>{props.children}</label>
    </div>
  );
}

Switch.propTypes = {
  isActived: T.bool,
  switch: T.func,
  children: T.string,
  field: T.string,
};

export default radium(Switch);



// WEBPACK FOOTER //
// ./components/Switch.js